import { render, staticRenderFns } from "./POIList.vue?vue&type=template&id=39b76848&"
import script from "./POIList.vue?vue&type=script&lang=js&"
export * from "./POIList.vue?vue&type=script&lang=js&"
import style0 from "./POIList.vue?vue&type=style&index=0&id=39b76848&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports